import { IPPool } from './ip-pool'
export class NetworkProfile {
    public networkId: string;
    public networkName: string;
    public networkType: string;
    public ipPool: IPPool;
    public transitPool: IPPool;
    public tags: Array<string> = new Array<string>();
    public isItNewlyAdded:boolean = false; 
}


// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/model/network-profile.ts